import { MANUAL_NEWS_ENTRIES } from "./news-entries-manual";
import { GENERATED_NEWS_ENTRIES } from "./news-entries.generated";
import type { NewsCategory, NewsEntry, NewsSortFilter } from "./news-types";

export type { NewsCategory, NewsEntry, NewsSortFilter };

/** Full feed — manual pins first, then generated git history (newest first). */
export const NEWS_ENTRIES: NewsEntry[] = [...MANUAL_NEWS_ENTRIES, ...GENERATED_NEWS_ENTRIES];

export function filterNewsEntries(filter: NewsSortFilter, source = NEWS_ENTRIES): NewsEntry[] {
    let list: NewsEntry[];
    if (filter === "bug-fix" || filter === "gameplay" || filter === "settings" || filter === "visual") {
        list = source.filter((e) => e.category === filter);
    } else {
        list = [...source];
    }
    if (filter === "oldest") {
        list = [...list].reverse();
    }
    return list;
}
